import { EMPTY_FUNCTION } from '../../../constants/common'
import { DraftFormPopupContainer } from '../../Draft'
import {
  useRentalPortalListingDraft,
  useRentalPortalListingFormCloseConfirmation,
} from '../RentalPortalListing.hooks'

function RentalPortalListingFormPopupContainer({
  hasSavedRecord,
  title,
  onClose,
  onSubmitConfirm,
  ...containerProps
}) {
  const { getLatestDraft, setDraft } = useRentalPortalListingDraft()

  const { Confirmation, handleSubmitConfirm } =
    useRentalPortalListingFormCloseConfirmation({
      hasSavedRecord,
      onClose,
      onSubmitConfirm,
    })

  return (
    <DraftFormPopupContainer
      {...containerProps}
      Confirmation={Confirmation}
      getLatestDraft={getLatestDraft}
      setDraft={hasSavedRecord ? EMPTY_FUNCTION : setDraft}
      titleKey={title}
      onClose={onClose}
      onSubmitConfirm={handleSubmitConfirm}
    />
  )
}

export default RentalPortalListingFormPopupContainer
